$(document).ready(function() {

    
        // $("head").append('<link rel="stylesheet" href="/_biblioteki_/fancybox/jquery.fancybox.css"/>');
        // $("body").append('<script src="/_biblioteki_/fancybox/jquery.fancybox.min.js" async></script>');
  


    //ukrycie przycisku zadzwoń do nas

    $(".star-box-m a").click(function(e) {
        $(".nav-tabs #opinie").click();
    });
    $(".zobacz-opis").click(function(e) {
        $(".nav-tabs #opis").click();
    });


    //gwiazdki
    ratings("click", "active");
    ratings("mouseover", "active-h");
    ratings("mouseout", "active-h");

    function ratings(event, classEvt) {
        $(document).on(event, ".stars-setup label", function() {
            var $button = $(this);

            //index of selected item - label:nth-of-type(index)
            var index = $button.index();


            var labels = $button.closest(".stars-setup").find("label");

            //remove class on mouseout
            if (event == "mouseout") {
                labels.removeClass(classEvt);
            } else {
                labels.removeClass(classEvt);
                $button.addClass(classEvt);

                for (var i = 0; i < index + 1; i++) {
                    $button.closest(".stars-setup").find('label:nth-of-type(' + i + ')').addClass(classEvt);
                }
            }
        });
    }

    //ad data

    function addCountDate(box) {
        let countDownDate = new Date(box.attr('data-date')).getTime();
        let stoper = box.siblings(".stoper");

        let x = setInterval(function() {

            let now = new Date().getTime();
            let distance = countDownDate - now;

            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);



            stoper.find(".days").html(days);
            stoper.find(".hours").html(hours);
            stoper.find(".minutes").html(minutes);
            stoper.find(".seconds").html(seconds);

            if (seconds < 0) {

                stoper.parents(".final-date-box").css("display", "none");
            }

        }, 0);
    }

    $(".final-date").each(function() {
        addCountDate($(this));
    });



    //opinie

    $(".see-all").click(function() {
        let val = $(this).attr("data-pr-id");
        let box = $(this).parent().siblings(".opinion-container");
        $.get('/a', {
                a: "opinie",
                produkt: val
            },
            function(data) {
                box.append(data);
            });
        $(".see-all").css("display", "none");

    });

    $("body").on("click", ".opinion-box-hand .hand-up", function() {
        let val = $(this).attr("data-opi-id");
        let box = $(this).children("span");
        $.get('/a', {
                a: "opiniaTak",
                opiniaId: val
            },
            function(data) {
                box.html(data);
            });
    });

    $("body").on("click", ".opinion-box-hand .hand-down", function() {

        let val = $(this).attr("data-opi-id");
        let box = $(this).children("span");
        $.get('/a', {
                a: "opiniaNie",
                opiniaId: val
            },
            function(data) {
                box.html(data);
            });

    });



    //opinie-end


    $('.btn-filtr').click(function() {

        $(".menu-left").slideToggle("fast");
    });

    //scroll top



    let scrollTop = $(".scroll-top");

    /* $(window).scroll(function () {        
         let topPos = $(this).scrollTop(); 
         if (topPos > 100) {
              $(scrollTop).css("opacity", "1");
         } else {
              $(scrollTop).css("opacity", "0");          }

    }); */
    $(scrollTop).click(function() {
        $('html, body').animate({
            scrollTop: 0
        }, 800);
        return false;
    });





    //slider on mobile
    function checkArrow() {
        if ($(".card-product .product-gallery figure.active").prev().is("figure")) {
            $(".card-product .arrow-left").css("color", "#000");
        } else {
            $(".card-product .arrow-left").css("color", "#eaeaea");
        }

        if ($(".card-product .product-gallery figure.active").next().is("figure")) {
            $(".card-product .arrow-right").css("color", "#000");
        } else {
            $(".card-product .arrow-right").css("color", "#eaeaea");
        }
    }
    checkArrow();

    $(".arrow-left").click(function() {
        if ($(".card-product .product-gallery figure.active").prev().is("figure")) {
            $(".card-product .product-gallery figure.active").removeClass("active").prev("figure").addClass("active");
        }
        checkArrow();
    });

    $(".arrow-right").click(function() {
        if ($(".card-product .product-gallery figure.active").next().is("figure")) {
            $(".card-product .product-gallery figure.active").removeClass("active").next("figure").addClass("active");
        }
        checkArrow();
    });


    //fixed menu-card product

    $(window).scroll(function() {
        if ($(window).scrollTop() >= 900) {
            $('.fixed-header').slideDown("fast");


        } else {
            $('.fixed-header').slideUp("fast");
        }
    });

    //show window - zapytaj o ten produkt
    $("body").on("click", ".product-download-invoice", function() {
        //var pid = $(this).attr("id");
        var pid = $(this).attr("data-id-prod");
        var akcja = "oknoWygenerujFaktura";
        //alert('knock knock' + pid);
        $.get('/a', {
                a: akcja,
                produkt: pid
            },
            function(data) {
                $('.result-1').html(data);
            });
    });

    $("body").on("click", ".product-opinion-btn", function() {

        //var pid = $(this).attr("id");
        var pid = $(this).attr("data-id-prod");
        var akcja = "oknoOpinie";
        //alert('knock knock' + pid);
        $.get('/a', {
                a: akcja,
                produkt: pid
            },
            function(data) {
                $('.result-1').html(data);
            });
    });




    $("body").on("click", ".product-print-proposal", function() {

        //  var pid = $(this).attr("id");
        var pid = $(this).attr("data-id-prod");
        var akcja = "oknoWygenerujWniosek";
        //alert('knock knock' + pid);
        $.get('/a', {
                a: akcja,
                produkt: pid
            },
            function(data) {
                $('.result-1').html(data);
            });
    });



    $("body").on("click", ".product-ask-btn", function() {

        //  var pid = $(this).attr("id");
        var pid = $(this).attr("data-id-prod");
        var akcja = "oknoZapytaj";
        //alert('knock knock' + pid);
        $.get('/a', {
                a: akcja,
                produkt: pid
            },
            function(data) {
                $('.result-1').html(data);
            });
    });


    //     fieldset dropdown


    $('.form-group').each(function() {
        if ($(this).find('.form-control').val() != "") {
            $(this).find(".form-control-placeholder").addClass('form-control-focus');
        }
    });

    $('.form-group .form-control').on('autocompletechange change', function() {
        $(this).siblings(".form-control-placeholder").addClass('form-control-focus')

    }).change();

    $('.form-control').blur(function() {
        if ($(this).val() == '') {
            if ($(this).siblings().hasClass("always-float")) {

            } else {
                $(this).siblings().removeClass('form-control-focus');
            }
        };
    });


    $('.form-control').focus(function() {
        $(this).siblings('.form-control-placeholder').addClass('form-control-focus');
    });

    $('.form-control-placeholder').click(function() {
        $(this).addClass('form-control-focus');
    });


    //formularz - flow labels -koniec */
    var invalidBlockEmpty = '<div class="form-invalid">To pole nie może być puste</div>';
    var invalidFour = '<div class="form-invalid">To pole musi zawierac minimum 4 znaki</div>';
    var invalidPhone = '<div class="form-invalid">Wpisz poprawny numer telefonu</div>';
    var invalidEmail = '<div class="form-invalid">Wpisz poprawny adres e-mail</div>';
    var invalidDate = '<div class="form-invalid">Wpisz poprawny format daty 0000-00-00 </div>';
    var invalidAgree = '<div class="form-invalid">Zgoda jest wymagana</div>';

    function validateEmail($email) {
        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

        if (emailReg.test($email.val())) {} else {
            $email.after(invalidEmail);
        }
        return emailReg.test($email.val());
    }

    function validatePhone(txtPhone) {
        var filter = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
        if (filter.test(txtPhone.val())) {} else {
            txtPhone.after(invalidPhone);
        }
        return filter.test(txtPhone.val());
    }

    function validateDate(dateString) {
        var regEx = /^\d{4}-\d{2}-\d{2}$/;
        if (regEx.test(dateString.val())) {} else {
            dateString.after(invalidDate);
        }
        return regEx.test(dateString.val());
    }

    function validateChecked(check) {
        if (check.prop("checked") == false) {
            check.parent().append(invalidAgree);
        }
    }

    $("input").focus(function() {
        if ($(this).siblings(".form-invalid") != null) {
            $(this).siblings(".form-invalid").remove();
        }
    })
    $('input[type="checkbox"]').click(function() {
        if ($(this).siblings(".form-invalid") != null) {
            $(this).siblings(".form-invalid").remove();
        }
    })


    //formularze

    //prezentacja w domu
    $("#pr-form #pr_btn_send").click(function() {
        $(this).preventDefault;

        $('#pr-form .form-invalid').each(function() {
            $(this).remove();
        });

        $("#pr-form input").each(function() {
            if ($(this).val() == '') {
                $(this).after(invalidBlockEmpty);
            } else {}
        });

        if ($("#pr-form #pr_name_surename").val().length < 4) {
            $($("#pr-form #pr_name_surename")).after(invalidFour);
        }


        validateChecked($("#pr-form #pr_terms"));
        validateDate($('#pr-form #pr_therm'));
        validatePhone($("#pr-form #pr_phone"));
        validateEmail($("#pr-form #pr_address"));


        if ($('#pr-form .form-invalid').length == 0) {

            let name = $("#pr-form #pr_name_surename").val();
            let adress = $("#pr-form #pr_address").val();
            let phone = $("#pr-form #pr_phone").val();
            let data1 = $("#pr-form #pr_therm").val();

            let id = $("#pr-form").attr('data-pr-id');

            $.post('/a', {
                    a: "prezentacja",
                    imieNazwisko: name,
                    adres: adress,
                    numerTelefonu: phone,
                    data: data1,
                    id: id,
                },

                function(data) {
                    if (data == "true") {
                        $("#pr_alert").css("display", "block");
                        $(".pr-box").css("display", "none");
                    }
                });
        }
    })

    //PFRON
    $("#pfr-form #pfr_btn_send").click(function() {


        $('#pfr-form .form-invalid').each(function() {
            $(this).remove();
        });

        $("#pfr-form input").each(function() {
            if ($(this).val() == '') {
                $(this).after(invalidBlockEmpty);
            } else {}
        });


        validateChecked($('#pfr-form input[type="checkbox"]'));
        validatePhone($('#pfr-form input.pfr-phone'));
        /*validateEmail($('#pfr-form input[type="email"]')); */


        if ($('#pfr-form .form-invalid').length == 0) {
            /*let adress = $('#pfr-form input[type="email"]').val();*/
            let phone = $('#pfr-form input.pfr-phone').val();
            let id = $("#pfr-form").attr('data-pr-id');


            $.post('/a', {
                    a: "pfron",

                    /*adres: adress,*/
                    numerTelefonu: phone,

                    id: id,
                },

                function(data) {
                    if (data == "true") {
                        $("#pfr_alert").css("display", "block");
                        $(".pfr-box").css("display", "none");
                    }
                });
        }
    })

    // input do wpisania hasła

    $("input.invalid").bind("change keyup", function() {
        if ($(this)[0].validity.valid) {
            $(this).removeClass("invalid-input");
        }
    })

    $('a[href="#tab6"').click(function() {
        $(".video").click();
    })


    function checkConfiguration(form) {
        let table = form.find("table[data-ilosc]");

        let btn = form.find('[type="submit"]');
        let checkAnswer = 0;

        function liczKonf() {
            checkAnswer = 0;
            table.each(function() {
                let ilosc = $(this).data("ilosc");
                let iloscChecked = 0;
                let input = $(this).find("input[data-licz]");
                input.each(function() {
                    iloscChecked += parseInt($(this).val());
                })
                if (ilosc == iloscChecked) {
                    checkAnswer += 1;
                    $(this).prev(".konfiguracja-text").find("span").removeClass("alert-danger");
                } else {
                    $(this).prev(".konfiguracja-text").find("span").addClass("alert-danger");
                }
            })
        }

        form.find("input[data-licz]").on('change', function() {
            liczKonf();
            if (checkAnswer == table.length) {
                btn.removeClass("disabled");
            } else {
                btn.addClass("disabled");
            }
        })

        btn.click(function(e) {

            e.preventDefault();
            liczKonf();
            if (checkAnswer == table.length) {
                form.submit();
            } else {
                btn.addClass("disabled");
            }
        })
    }


    if ($(".konfiguracja-licz").length > 0) {
        $(".konfiguracja-licz").each(function() {
            checkConfiguration($(this));
        })
    }



    if ($("#koszykRozmiary").length || $("#koszykKolory").length) {

        $("#koszykRozmiary, #koszykKolory").on("change", function() {

            $(".card-form-invalid").remove();

        })

        function blockForm(name) {
            $(".card-product .product-description form").css("position", "relative");
            $(".card-product .product-description form").after("<span class='card-form-invalid' style='width:100%; margin-top:5px; display:block; color: #d60014; font-weight:700; text-align:right'>Wybierz " + name + "</span>");
        }

        $(".card-product .product-description .btn-basket").click(function(e) {
            $(".card-form-invalid").remove();
            if ($("#koszykRozmiary").length) {

                if ($("#koszykRozmiary option:selected").val() == "0") {
                    e.preventDefault();
                    blockForm("rozmiar");
                }
            }
            if ($("#koszykKolory").length) {
                if ($("#koszykKolory option:selected").val() == "0") {
                    e.preventDefault();
                    blockForm("kolor");
                }

                let txtInSelect = $("#koszykKolory option:selected").text();
                let txtNiedostepny = "Niedostępny";
                if (txtInSelect.indexOf(txtNiedostepny) !== -1) {
                    e.preventDefault();
                    blockForm("inny kolor");
                }
            }

        })
    }


    number_format = function(number, decimals, dec_point, thousands_sep) {
        //number = number.toFixed(decimals);

        var nstr = number.toString();
        nstr += '';
        x = nstr.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? dec_point + x[1] : '';
        var rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1))
            x1 = x1.replace(rgx, '$1' + thousands_sep + '$2');

        return x1 + x2;
    }


    $(".custom-select").on("change", function() {
        let price = $(this).find(':selected').html();
        if (price == "wybierz") {
            $("#cena .price>small").css("display", "inline");
        } else {
            $("#cena .price>small").css("display", "none");
        }
        let price3 = 0;
        if ($(this).siblings(".custom-select").length > 0) {

            price3 = $(this).siblings(".custom-select").find(':selected').html();
            price3 = price3.substring(price3.indexOf('('), price3.indexOf(')'));
            price3 = price3.replace("(", "");
            price3 = price3.replace("+", "");
            price3 = price3.replace(" ", "");
            price3 = price3.replace("zł", "");
            price3 = price3.replace(",", ".");
            price3 = price3.replace(" ", "");           
            
            if (price3.length == 0) {
                price3 = 0;
            }
            price3 = parseFloat(price3);
        }

        price = price.substring(price.indexOf('('), price.indexOf(')'));
        price = price.replace("(", "");
        price = price.replace("+", "");
        price = price.replace(" ", "");
        price = price.replace("zł", "");
        price = price.replace(",", ".");
        price = price.replace(" ", "");
  
        if (price.length == 0) {
            price = 0;
        }        

        price = parseFloat(price);
        price = price + price3 + parseFloat($("#pricevalue").data("price"));
       
        price = price.toFixed(2);
        price = price.toString().replace(".", ",");
        price = price.toString().replace(",00", "");

        $("#pricevalue").html(number_format(price, 2, ',', ' '));

    })


    $(".f-dev-box a").click(function(e) {
        e.preventDefault();
        let href = $(this).attr("href");
        href = href.replace("#", ".");
        let offsetTop = $(href).offset().top - 160;
        if (offsetTop <= 0) {
            offsetTop = $("a[href='#collapseFour']").offset().top -150;
        }
        if ($(href).length > 0) {
            $([document.documentElement, document.body]).animate({
                scrollTop: offsetTop
            }, 500);
            if( $("a[href='#collapseFour']").attr('aria-expanded')=="true"){
                return;
            }
            $(href).click();
        }
    })


});